export enum DateFormat {
  YEAR_MONTH_DAY = 'yyyy-MM-dd',
  MONTH_DAY_YEAR = 'MMMM dd, yyyy',
  DAY_MONTH_YEAR = 'dd/MM/yy',
  SHORT_MONTH_DAY = 'LLL d', // ex. JAN 28
  MONTH_DAY_SHORT_YEAR = 'MM/dd/yy',
}
